const siteConfig = {
  brandName: "velvetvogue",
  brandTitle: "velvetvogue",
  companyName: "DAGOTITY INC",
  founderName: "velvetvogue Studio",
  logo: {
    text: "velvetvogue",
    initial: "V",
    image: "/img/velvetvogue-logo.svg",
  },
  tagline: "Modern footwear · Hong Kong",
  description:
    "velvetvogue creates versatile contemporary footwear with balanced proportions, considered materials and everyday comfort.",
  contact: {
    email: "sample@velvetvogue.club",
    address: "13918 E Mississippi Ave #60260, Aurora, CO 80012, US",
    openingHours: "Monday – Friday, 10am – 6pm HKT",
  },
  shipping: { flatRate: 9.99 },
  currency: "USD",
  locale: "en-US",
  storageKey: "velvetvogue-store-v1",
  categories: ["Oxfords", "Derbies", "Boots", "Monk Straps", "Loafers"],
  collections: ["velvetvogue Core Collection", "velvetvogue Studio Collection"],
};

export default siteConfig;
